(function ($) {
    if($('.js-slick-grid')) {
        $('.js-slick-grid').each(function() {
            var instance = $(this);
            instance.slick({
                dots: true,
                prevArrow: instance.closest('.c-grid-gallery').find('.c-pagination__btn--prev'),
                nextArrow: instance.closest('.c-grid-gallery').find('.c-pagination__btn--next'),
                appendDots: instance.closest('.c-grid-gallery').find('.c-pagination__numeration'),
                customPaging: function(slider, pageIndex) {
                    return `<button class="c-pagination__btn c-pagination__btn--pagination">` + (pageIndex + 1) + `</button>`;
                }
            });
        });
    }
}(jQuery));



// WEBPACK FOOTER //
// ./src/app/components/grid-gallery/grid-gallery.js